import {
  AssetUtil,
  DEFAULT_SUPPORT_VIDEO_TYPES,
  MediaHelpers,
  videoAssetMigrations,
  videoAssetProps
} from "@tldraw/editor";
class VideoAssetUtil extends AssetUtil {
  static type = "video";
  static props = videoAssetProps;
  static migrations = videoAssetMigrations;
  options = {
    supportedMimeTypes: null
  };
  getDefaultProps() {
    return {
      w: 0,
      h: 0,
      name: "",
      isAnimated: true,
      mimeType: null,
      src: null
    };
  }
  getSupportedMimeTypes() {
    return this.options.supportedMimeTypes ?? DEFAULT_SUPPORT_VIDEO_TYPES;
  }
  async getAssetFromFile(file, assetId) {
    let fileType = file.type;
    if (fileType === "video/quicktime") {
      fileType = "video/mp4";
    }
    const doc = this.editor.getContainerDocument();
    const size = await MediaHelpers.getVideoSize(file, doc);
    return {
      id: assetId,
      type: "video",
      typeName: "asset",
      props: {
        name: file.name,
        src: "",
        w: size.w,
        h: size.h,
        fileSize: file.size,
        mimeType: fileType,
        isAnimated: true
      },
      meta: {}
    };
  }
}
export {
  VideoAssetUtil
};
//# sourceMappingURL=VideoAssetUtil.mjs.map
